import { useEffect, useState } from 'react'
import { animated, useSprings } from '@react-spring/web'

import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'

let _step = Math.floor(Date.now() / 520) % 3
const _listeners = new Set()
setInterval(() => {
  _step = Math.floor(Date.now() / 520) % 3
  _listeners.forEach((fn) => fn(_step))
}, 520)

export default function Loader() {
  const theme = useTheme()
  const [step, setStep] = useState(_step)

  useEffect(() => {
    _listeners.add(setStep)
    return () => {
      _listeners.delete(setStep)
    }
  }, [])

  const springs = useSprings(
    ICONS.length,
    ICONS.map((_, i) => ({
      opacity: step === i ? 1 : 0.18,
      scale: step === i ? 1.18 : 1,
      y: step === i ? -6 : 0,
      config: step === i ? { tension: 320, friction: 22 } : { tension: 80, friction: 26 },
    }))
  )

  return (
    <Box sx={styles.wrapper}>
      {springs.map((spring, i) => {
        const Icon = ICONS[i]
        return (
          <Box
            key={i}
            component={animated.div}
            style={{
              opacity: spring.opacity,
              scale: spring.scale,
              y: spring.y,
              filter: spring.opacity.to((o) => `drop-shadow(0 0 ${o * 18}px ${theme.palette.primary.main})`),
            }}
            sx={styles.icon}
          >
            <Icon />
          </Box>
        )
      })}
    </Box>
  )
}

export function LoadingScreen() {
  return (
    <Box sx={styles.screen}>
      <Box sx={styles.screenGradient} />
      <Loader />
    </Box>
  )
}

const styles = {
  wrapper: {
    position: 'fixed',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 3,
  },
  icon: {
    color: 'brand.magenta',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  screen: {
    position: 'fixed',
    inset: 0,
    overflow: 'hidden',
    backgroundColor: 'background.default',
  },
  screenGradient: {
    position: 'absolute',
    inset: 0,
    zIndex: 0,
    background: 'radial-gradient(circle at 50% 50%, rgba(156, 39, 176, 0.03) 0%, rgba(0, 0, 0, 0.12) 100%)',
  },
}

const QIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37">
    <path
      fill="currentColor"
      d="M29.35,33.381l2.98,3.09h4.525l-5.056-5.211.155-.163c3.321-3.491,5.005-7.773,5.005-12.727C36.957,8.069,28.84,0,18.478,0S0,8.069,0,18.371s8.117,18.371,18.478,18.371c5.92,0,9.524-2.446,10.708-3.249l.163-.111ZM26.588,31.024c-3.048,1.993-6.092,2.411-8.109,2.411-8.187,0-14.848-6.758-14.848-15.064S10.291,3.307,18.478,3.307s14.848,6.758,14.848,15.064c0,3.882-1.345,7.386-3.891,10.135l-.167.181-6.413-6.577h-4.525l8.495,8.759-.237.155Z"
    />
  </svg>
)

const PillIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
    <g transform="rotate(-45 18 18)">
      <path d="M10 26a8 8 0 0 0 8 8h1a8 8 0 0 0 8-8v-6H10v6z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 2a8 8 0 0 0-8 8v10h17V10a8 8 0 0 0-8-8h-1zm.5 2a6.5 6.5 0 0 0-6.5 6.5V18h13v-7.5A6.5 6.5 0 0 0 18.5 4z"
        fill="currentColor"
      />
    </g>
  </svg>
)

const PlusIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
    <path d="M20 4h-4v12H4v4h12v12h4V20h12v-4H20z" fill="currentColor" />
  </svg>
)

const ICONS = [QIcon, PillIcon, PlusIcon]
